import styled, { keyframes } from 'styled-components';
import { fadeIn, fadeOut } from 'styles/animations';

const anim = keyframes`
	0% { transform: translate(0, 0); }
	100% { transform: translate(24px, 0); }
`;

export const Container = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background-color: ${({ theme }) => theme.colors.bg1};
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Content = styled.div`
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;

	& div {
		position: absolute;
		top: 33px;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		background: #6f48bf;
	}

	& div:nth-child(1) {
		left: 8px;
		animation: ${fadeIn} 0.6s infinite;
	}
	& div:nth-child(2) {
		left: 8px;
		animation: ${anim} 0.6s infinite;
	}
	& div:nth-child(3) {
		left: 32px;
		animation: ${anim} 0.6s infinite;
	}
	& div:nth-child(4) {
		left: 56px;
		animation: ${fadeOut} 0.6s infinite;
	}
`;
